import { useLayoutEffect } from "react";

export function useFillHeight(ref) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const fit = () => {
      const main = el.closest("main");
      const z = (main && parseFloat(getComputedStyle(main).zoom)) || 1;
      let footer = 0;
      for (let s = el.nextElementSibling; s; s = s.nextElementSibling) if (s.offsetHeight) footer += s.offsetHeight + (parseFloat(getComputedStyle(s).marginTop) || 0);
      const top = el.getBoundingClientRect().top;
      el.style.height = Math.max(200, (window.innerHeight - top) / z - footer - 26) + "px";
    };
    fit();
    const ro = new ResizeObserver(fit);
    const panel = document.querySelector("[data-testid=bar-panel]");
    if (panel) ro.observe(panel);
    if (el.parentElement) ro.observe(el.parentElement);
    window.addEventListener("resize", fit);
    return () => { ro.disconnect(); window.removeEventListener("resize", fit); };
  }, [ref]);
}
